// Global visibility switch for the shared Co-Pilot compliance disclaimer (COPILOT_DISCLAIMER).
//
// WHY (CR-20260723-003): the disclaimer added in CR-20260720-001 (M8/R8) - the "Disclaimer: results
// are for informational and educational purposes only ..." line rendered under every Co-Pilot card
// and action button, including the OPG Preview-All bar - was turned OFF at the client's request. The
// client asked to DISABLE the feature, not to delete it.
//
// DISABLE, NOT REMOVE. Nothing about the disclaimer was taken out: the wording constant
// (copilot-disclaimer.ts) and all five render sites stay exactly as they were. Each render site simply
// guards its disclaimer element on this flag. Set this back to `true` to bring all five back at once -
// one value, no rebuild of the feature.
//
// KEPT SEPARATE from copilot-disclaimer.ts on purpose: that file is compliance-locked (its string is
// re-approved, never refactored). Visibility is an operational toggle, not a compliance edit, so it
// lives here and leaves the locked file untouched.
//
// Consumed by all five Co-Pilot result surfaces, mirroring COPILOT_DISCLAIMER:
//   copilot-shared/     opg-trade-card, opg-trade-stack (the Preview-All bar)
//   adjustment-pricing-grid/copilot/  apg-copilot-snippet-card
//   hedging-grid/copilot/             hg-copilot-solution-card, hg-copilot-close-all-card

export const COPILOT_DISCLAIMER_ENABLED = false;
